import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const GridRow = Atom.createRender(
  ({data, generateAttributes, attributes, classes, renderChild}) => (
    <div {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child) => renderChild(child))}
    </div>
  )
);

const config = createIntegratedAtom({
  displayName: 'Row',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          gridColumnGap: px(8),
          justifyContent: 'flex-start',
        },
      },
    },
  },
  render: GridRow,
  fields: {children: TListOfElement},
});

export default config;
